__webpack_require__.p = "/wishlist-client/";